import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface TabState {
  tabs: Record<string, string> // pageId -> activeTab

  setTab: (pageId: string, tab: string) => void
  getTab: (pageId: string, defaultTab: string) => string
}

export const useTabStore = create<TabState>()(
  devtools(
    persist(
      (set, get) => ({
        tabs: {},

        setTab: (pageId, tab) =>
          set((state) => ({
            tabs: { ...state.tabs, [pageId]: tab }
          })),

        getTab: (pageId, defaultTab) =>
          get().tabs[pageId] || defaultTab,
      }),
      { name: 'tab-state' }
    ),
    { name: 'TabStore' }
  )
)
